import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * The one loading state the brand uses: the X mark, breathing.
 *
 * It replaces a line of static text ("Loading event details...") and matches
 * both the pre-bootstrap splash inlined in index.html and the Flutter app's
 * splash, so the wait looks the same wherever a user meets it.
 *
 * Amber is fixed; the crossing bar follows the ground, exactly as the app's
 * BrandMark does. On the cream card that is the deep accent. The label
 * underneath carries the meaning, and that is ink on cream.
 */
@Component({
  selector: 'app-aurora-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="aurora-loader" role="status" [attr.aria-label]="label || 'Loading'">
      <div class="mark" [style.width.px]="size" [style.height.px]="size">
        <svg viewBox="0 0 56 56" aria-hidden="true">
          <g transform="translate(28 28)">
            <rect
              class="bar amber"
              x="-28"
              y="-8"
              width="56"
              height="16"
              rx="8"
              transform="rotate(-42)"
            />
            <rect
              class="bar cross"
              x="-28"
              y="-8"
              width="56"
              height="16"
              rx="8"
              transform="rotate(42)"
            />
          </g>
        </svg>
      </div>
      <p class="label" *ngIf="label">{{ label }}</p>
    </div>
  `,
  styleUrls: ['./aurora-loader.component.scss'],
})
export class AuroraLoaderComponent {
  /** What is being waited for. Omit for a bare mark. */
  @Input() label: string | null = 'Loading event details';

  /** Edge length of the mark in px. */
  @Input() size = 64;
}
